(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("msal"));
	else if(typeof define === 'function' && define.amd)
		define("react-aad-msal", ["react", "msal"], factory);
	else if(typeof exports === 'object')
		exports["react-aad-msal"] = factory(require("react"), require("msal"));
	else
		root["react-aad-msal"] = factory(root["react"], root["msal"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__) {
return 